import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./Preloader.css";
import logo from "../../assets/logo2.png"; // ✅ use the imported variable

export default function Preloader({ show = true }) {
  // Keep mounted while running the fade-out transition.
  const [render, setRender] = useState(show);
  const [hidden, setHidden] = useState(!show);
  const [imgFailed, setImgFailed] = useState(false); // fallback to letter if image fails

  useEffect(() => {
    if (!show) {
      setHidden(true); // triggers CSS fade
      const t = setTimeout(() => setRender(false), 450); // match CSS .45s
      return () => clearTimeout(t);
    }
    setRender(true);
    const t = setTimeout(() => setHidden(false), 0);
    return () => clearTimeout(t);
  }, [show]);

  if (!render) return null;

  return createPortal(
    <div className={`preloader ${hidden ? "is-hidden" : ""}`} aria-hidden={hidden}>
      <div className="preloader__ring" role="img" aria-label="Loading">
        <svg className="preloader__svg" viewBox="0 0 120 120" aria-hidden="true">
          <defs>
            <linearGradient id="pl-grad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="var(--accent)" />
              <stop offset="100%" stopColor="var(--accent-2)" />
            </linearGradient>
          </defs>

          {/* track */}
          <circle cx="60" cy="60" r="46" fill="none" stroke="rgba(22,12,62,.15)" strokeWidth="4" />

          {/* animated arc */}
          <circle
            className="pl-arc"
            cx="60" cy="60" r="46" fill="none"
            stroke="url(#pl-grad)" strokeWidth="4" strokeLinecap="round"
            strokeDasharray="289" strokeDashoffset="220"
          />
        </svg>

        {/* perfectly centered logo */}
        <div className="preloader__logo">
          {imgFailed ? (
            <span>A</span> // fallback initial (change to your brand initial)
          ) : (
            <img src={logo} alt="Logo" onError={() => setImgFailed(true)} />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
